import React, { useState } from 'react';
import { makeStyles, AppBar, Toolbar, IconButton, createStyles, Theme, Tooltip, Menu, MenuItem, Button } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import TuneIcon from '@material-ui/icons/Tune';
import AccountCircle from '@material-ui/icons/AccountCircle';
import ToaTitleWhite from 'assets/images/toa-title-white.svg';
import styled, { keyframes } from 'styled-components';
import './Header.scss';
import EASTER_EGG_IDS from 'helpers/easterEggConstants';
import { useEasterEggFound } from 'helpers/easterEgghelper';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
// modules that don't provide built-in typings, import with require
const ReactAnimations = require('react-animations');
const { hinge } = ReactAnimations;

// Component Styles
const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		appBar: {
			backgroundColor: '#3F158B',
		},
		menuButton: {
			marginRight: theme.spacing(2),
		},
	})
);

// Styled Component
const animationLength = 5000;
const AnimationDiv = styled.div`
	animation: ${animationLength}ms ${keyframes`${hinge}`};
`;

interface headerProps {
	userName: string;
	showMobileView: boolean;
	onTeamPanelButtonClick: () => void;
	onLeaderboardPanelButtonClick: () => void;
	onEggHuntClicked: () => void;
	onAboutClicked: () => void;
	onTermsClicked: () => void;
}

const Header: React.FC<headerProps> = props => {
	const classes = useStyles();
	const easterEggFound = useEasterEggFound(EASTER_EGG_IDS.COMING_UNGLUED);
	const { userName, showMobileView, onTeamPanelButtonClick, onLeaderboardPanelButtonClick, onEggHuntClicked, onAboutClicked, onTermsClicked } = props;
	const [logoHinge, setLogoHinge] = useState(false);
	const [logoTitleClicked, setLogoTitleClicked] = useState(0);
	const [tooltipText, settooltipText] = useState('');
	const [anchorEl, setAnchorEl] = useState(null);

	let view;

	const onLogoTitleClicked = () => {
		if (logoTitleClicked < 3) {
			setLogoTitleClicked(logoTitleClicked + 1);
		} else {
			setLogoTitleClicked(logoTitleClicked + 1);
			setLogoHinge(true);
			setTimeout(() => {
				setLogoTitleClicked(0);
				setLogoHinge(false);
			}, animationLength);
		}
		handleLogoClicked(logoTitleClicked + 1);
	};

	const handleLogoClicked = (clickCount: number) => {
		if (clickCount === 0) {
			settooltipText('');
		} else if (clickCount === 1) {
			settooltipText('🥚');
		} else if (clickCount === 2) {
			settooltipText('that tickles');
		} else if (clickCount === 3) {
			settooltipText('uh-oh, glue is coming loose');
		} else if (clickCount === 4) {
			settooltipText('wheeeeeeeeee');
			easterEggFound();
		}
	};

	if (logoHinge) {
		view = (
			<Tooltip title={tooltipText}>
				<AnimationDiv>
					<img src={ToaTitleWhite} className='toa-image-white' alt='toa-white' onClick={onLogoTitleClicked} />
				</AnimationDiv>
			</Tooltip>
		);
	} else {
		view = (
			<Tooltip title={tooltipText}>
				<img src={ToaTitleWhite} className='toa-image-white' alt='toa-white' onClick={onLogoTitleClicked} />
			</Tooltip>
		);
	}

	const handleClick = (event: any) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<AppBar position='fixed' className={classes.appBar}>
			<Toolbar>
				<div className='header-content__left-side'>
					{showMobileView && (
						<IconButton
							edge='start'
							className={`header__teams-button ${classes.menuButton}`}
							color='inherit'
							aria-label='menu'
							onClick={onTeamPanelButtonClick}
						>
							<MenuIcon />
						</IconButton>
					)}
					<div className='logoTitleWrapper'>{view}</div>
				</div>

				<div className='header-content__right-side'>
					{!showMobileView && (
						<Button onClick={handleClick} className='user-btn' endIcon={<ArrowDropDownIcon />}>
							{userName}
						</Button>
					)}
					{showMobileView && (
						<IconButton aria-label='account of current user' aria-controls='menu-appbar' aria-haspopup='true' onClick={handleClick} color='inherit'>
							<AccountCircle />
						</IconButton>
					)}
					<Menu
						id='profile-menu'
						className='profile-menu'
						getContentAnchorEl={null}
						anchorEl={anchorEl}
						keepMounted
						open={Boolean(anchorEl)}
						onClose={handleClose}
						variant={'menu'}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'right',
						}}
					>
						<MenuItem onClick={onEggHuntClicked}>Easter Egg Hunt</MenuItem>
						<MenuItem onClick={onAboutClicked}> About This App</MenuItem>
						<MenuItem onClick={onTermsClicked}>Terms of Use</MenuItem>
					</Menu>
					{showMobileView && (
						<IconButton
							edge='start'
							className='header__leaderboard-button'
							color='inherit'
							aria-label='menu'
							onClick={onLeaderboardPanelButtonClick}
						>
							<TuneIcon />
						</IconButton>
					)}
				</div>
			</Toolbar>
		</AppBar>
	);
};

export default Header;
